import {
  Box,
  Button,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
} from "@mui/material";
import React, {useState} from "react";
import * as workOrderApi from "../../api/workOrderApi/workOrderApi";
import SubTitle from "../../components/SubTitle";
import {workOrderRequestedListTableHead} from "../../models/clientModels/data/tableHeaderData";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {Link, useNavigate} from "react-router-dom";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {alertStateAtom} from "../../Recoil/Atom/AlertAtom";
import {levelSelector, tokenSelector} from "../../Recoil/Atom/authState";
import MWSkeleton from "../../components/MWSkeleton";
import {useGetQuery, useRemoveMutation} from "../../hooks/useQueryHooks";
import {typeValue} from "../../models/clientModels/data/selectList";
import {ResponseList, ResponseRemove} from "../../models/clientModels/interfaces/Response";
import {EQWorkOrder, getSerialNumber} from "../../models/serverModels/workOrder/EQWorkOrder";
import {PaginationContainer} from "../../styledComponents/StyledPagination";

const ListContainer = styled(Box)(({theme}) => ({
  minWidth: "1500px",
}));

const RequestedList = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const tokenState = useRecoilValue(tokenSelector);
  const userLevel = useRecoilValue(levelSelector);
  const setAlertState = useSetRecoilState(alertStateAtom);

  const [page, setPage] = useState<number>(1);

  const {
    data: requestedList,
    isLoading,
    isFetching,
  } = useGetQuery<ResponseList<EQWorkOrder>>({
    key: ["RequestedList", {token: tokenState, page}],
    api: () => workOrderApi.RequestedList({token: tokenState, page}),
  });

  const {mutate: removeMutate} = useRemoveMutation<ResponseRemove, Params.Remove>({
    api: workOrderApi.remove,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries("RequestedList");
      },
    },
  });

  const paginationHandleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  return (
    <ListContainer>
      <SubTitle subTitle="점검의뢰 요청 목록" />
      <TableContainer component={Paper} sx={{marginTop: "16px"}}>
        <Table>
          <TableHead>
            <TableRow>
              {workOrderRequestedListTableHead.map((item, index) => (
                <TableCell key={index} align="center">
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading && isFetching ? (
              <MWSkeleton row={12} column={11} />
            ) : (
              requestedList?.items.map((item, index) => (
                <TableRow key={item.uid}>
                  <TableCell align="center">
                    {page === 1 ? index + 1 : (page - 1) * 20 + index + 1}
                  </TableCell>
                  <TableCell align="center">
                    <Link to={`/WorkOrder/View/${item.uid}`}>{getSerialNumber(item)}</Link>
                  </TableCell>
                  <TableCell align="center">{item.department}</TableCell>
                  <TableCell align="center">{item.writerName}</TableCell>
                  <TableCell align="center">
                    {typeValue?.map((v) => (v.value === item.specification?.type ? v.label : ""))}
                  </TableCell>
                  <TableCell align="center">
                    <Link to={`/Equipment/Detail/${item.specification.uid}`}>
                      {item.specification.identifyNumber}
                    </Link>
                  </TableCell>
                  <TableCell align="center">{item.specification.name}</TableCell>
                  <TableCell align="center">{item.specification.eqLevel}</TableCell>
                  <TableCell align="center">{item.requestContent}</TableCell>
                  <TableCell align="center">
                    {new Date(item?.requestDate).getFullYear()}년
                    {new Date(item?.requestDate).getMonth() + 1}월
                    {new Date(item?.requestDate).getDate()}일
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="success"
                      size="small"
                      style={{marginRight: "12px"}}
                      onClick={() => {
                        navigate(`/WorkOrder/Edit/${item.uid}`);
                      }}
                    >
                      편집
                    </Button>
                    {userLevel === 3 && (
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        onClick={() => {
                          setAlertState({
                            toggle: true,
                            message: "등록된 점검의뢰 요청을 삭제하시겠습니까?",
                            execution: () => removeMutate({token: tokenState, id: item.uid}),
                          });
                        }}
                      >
                        삭제
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {/* 페이지네이션 */}
      <PaginationContainer>
        <Pagination
          count={requestedList?.maxPage}
          page={page}
          onChange={paginationHandleChange}
          variant="outlined"
          color="primary"
          shape="rounded"
        />
      </PaginationContainer>
    </ListContainer>
  );
};

export default RequestedList;
